(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jr-reviewsconfotos"] && !Shopify.designMode) return;
  try {
    
(function () {
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initTst(root) {
    if (!root || root.dataset.tstReady) return;
    root.dataset.tstReady = '1';

    var track = root.querySelector('.tst-track');
    var vp = root.querySelector('.tst-viewport');
    var btnP = root.querySelector('.tst-btn-prev');
    var btnN = root.querySelector('.tst-btn-next');
    if (!track || !vp) return;

    var autoOn = root.getAttribute('data-autoplay') === 'true' && !reduced;
    var intervalMs = (parseFloat(root.getAttribute('data-interval')) || 4) * 1000;
    var real = [], N = 0, clonesLead = 0, step = 0, index = 0;
    var timer = null;
    var dragX = null, dx = 0;

    function measure() {
      var cs = getComputedStyle(track);
      var gap = parseFloat(cs.columnGap || cs.gap) || 0;
      var first = track.querySelector('.tst-slide');
      if (!first) return 0;
      return first.getBoundingClientRect().width + gap;
    }

    function setX(anim) {
      if (!anim) track.style.transition = 'none';
      track.style.transform = 'translate3d(' + (-index * step) + 'px,0,0)';
      if (!anim) { void track.offsetWidth; track.style.transition = ''; }
    }

    function build(keepReal) {
      track.querySelectorAll('.tst-clone').forEach(function (n) { n.remove(); });
      real = Array.prototype.slice.call(track.children);
      N = real.length;
      if (!N) return;
      step = measure();
      var need = Math.ceil(vp.clientWidth / step) + 1;
      var copies = Math.max(1, Math.ceil(need / N));
      clonesLead = copies * N;
      var pre = document.createDocumentFragment();
      var post = document.createDocumentFragment();
      for (var c = 0; c < copies; c++) {
        real.forEach(function (s) {
          var a = s.cloneNode(true), b = s.cloneNode(true);
          a.classList.add('tst-clone'); b.classList.add('tst-clone');
          a.setAttribute('aria-hidden', 'true'); b.setAttribute('aria-hidden', 'true');
          pre.appendChild(a); post.appendChild(b);
        });
      }
      track.insertBefore(pre, track.firstChild);
      track.appendChild(post);
      index = clonesLead + (keepReal || 0);
      setX(false);
    }

    function go(i) { index = i; setX(true); restartAuto(); }
    function next() { go(index + 1); }
    function prev() { go(index - 1); }

    track.addEventListener('transitionend', function (e) {
      if (e.target !== track) return;
      var r = index - clonesLead;
      if (r >= N) { index -= N; setX(false); }
      else if (r < 0) { index += N; setX(false); }
    });

    function stopAuto() { if (timer) { clearInterval(timer); timer = null; } }
    function startAuto() { if (autoOn && !timer) timer = setInterval(next, intervalMs); }
    function restartAuto() { stopAuto(); startAuto(); }
    vp.addEventListener('mouseenter', stopAuto);
    vp.addEventListener('mouseleave', startAuto);
    root.addEventListener('focusin', stopAuto);
    root.addEventListener('focusout', startAuto);

    if (btnN) btnN.addEventListener('click', next);
    if (btnP) btnP.addEventListener('click', prev);

    vp.addEventListener('pointerdown', function (e) {
      dragX = e.clientX; dx = 0;
      vp.classList.add('tst-dragging');
      track.style.transition = 'none';
      stopAuto();
    });
    window.addEventListener('pointermove', function (e) {
      if (dragX === null) return;
      dx = e.clientX - dragX;
      track.style.transform = 'translate3d(' + (-index * step + dx) + 'px,0,0)';
    });
    window.addEventListener('pointerup', function () {
      if (dragX === null) return;
      dragX = null;
      vp.classList.remove('tst-dragging');
      track.style.transition = '';
      if (dx <= -60) next();
      else if (dx >= 60) prev();
      else setX(true);
      dx = 0;
      startAuto();
    });

    var rT;
    window.addEventListener('resize', function () {
      clearTimeout(rT);
      rT = setTimeout(function () {
        var r = N ? (((index - clonesLead) % N) + N) % N : 0;
        build(r);
      }, 150);
    });

    build(0);
    startAuto();
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('.tst-section').forEach(initTst);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();

  } catch(e) { console.error(e); }
})();
})();
